export const practitionerActivityLeftFields = [
  {
    name: 'hoursWorked',
    label: 'Nombre d’heure travaillées (Heure de présence) :',
    placeholder: 'Ex : 150',
    end: 'h',
    required: true
  },
  {
    name: 'missedAppointments',
    label: 'Nombre de rendez-vous manqués / annulés :',
    placeholder: 'Ex : 8',
    required: true
  },
  {
    name: 'newPatients',
    label: 'Nombre de nouveaux patients (y compris Urgences) :',
    placeholder: 'Ex : 10',
    required: true
  },
  {
    name: 'treatmentPlansProposed',
    label: 'Nombre de plans de traitement proposés :',
    placeholder: 'Ex : 18',
    required: true
  },
  {
    name: 'crownsPlaced',
    label: 'Nombre de couronnes posées :',
    placeholder: 'Ex : 2',
    required: true
  },
  {
    name: 'activeOrthoPatients',
    label: 'Nombre de patients ortho en traitement actif :',
    placeholder: 'Ex : 16',
    required: true
  }
];
